/** 与后端 FundConstants.FUND_PLACEHOLDER_NAME 一致 */
export const FUND_PLACEHOLDER_NAME = '待同步';
